import './Avatar.css';

export function Avatar(props: { imageUrl: string | null; size?: number }) {
   return (
      <img
         className="avatar"
         src={props.imageUrl ?? '/assets/icons/avatar-icon.svg'}
         alt="avatar"
         width={props.size ?? 40}
         height={props.size ?? 40}
      />
   );
}
